import {
    DEFAULT_CURRENCY,
    DEFAULT_QUANTITY,
    normalizeCommitmentType,
    normalizeNumber,
    normalizeSegment,
} from '../../core/normalizers';
import type { TrackingCommerce, TrackingItem } from '../../types';
import { GTMItemServiceType, GTMItemType, GTMOrderType } from '../../types';
import type { PublicServicePlanEventData, PublicServicePlanSource } from './types';

const UNLIMITED_DATA_VARIANT = 'Neriboti GB';

const mapPublicServicePlanToTrackingItem = (
    plan: PublicServicePlanSource,
    index: number,
    serviceType: GTMItemServiceType,
): TrackingItem => {
    const price = normalizeNumber(plan.price);
    const regularVariant = plan.isDataSizeDomesticTotalUnlimited
        ? UNLIMITED_DATA_VARIANT
        : plan.dataSizeDomesticTotalFormatted || '';

    return {
        type: GTMItemType.Product,
        id: plan.code,
        name: plan.name || '',
        brand: 'Telia',
        variant: [plan.cap?.name, regularVariant].filter(Boolean).join(' ') || undefined,
        category: plan.offerGroup,
        listId: plan.uniqueOfferId,
        listName: plan.offerGroup,
        index,
        originalPrice: normalizeNumber(plan.priceStandard) || price,
        price,
        discount: 0,
        quantity: DEFAULT_QUANTITY,
        commitmentType: normalizeCommitmentType(plan.contractDuration),
        serviceType,
    };
};

export const mapPublicServicePlansToTrackingCommerce = ({
    index: selectedIndex,
    plans,
    serviceType,
}: PublicServicePlanEventData): TrackingCommerce => ({
    orderType: GTMOrderType.Services,
    segment: normalizeSegment(plans[0]?.segment),
    currency: DEFAULT_CURRENCY,
    value: 0,
    itemListName: plans[0]?.offerGroup,
    paymentMethod: '',
    transactionId: '',
    items: plans.map((plan, index) =>
        mapPublicServicePlanToTrackingItem(
            plan,
            plans.length === 1 && selectedIndex !== undefined ? selectedIndex : index,
            serviceType,
        ),
    ),
});

export const mapPublicServicePlanLeadModalToTrackingCommerce = (
    plan: PublicServicePlanSource,
    index: number,
): TrackingCommerce => ({
    ...mapPublicServicePlansToTrackingCommerce({ plans: [plan], serviceType: GTMItemServiceType.NewSale }),
    items: [mapPublicServicePlanToTrackingItem(plan, index, GTMItemServiceType.NewSale)],
});
